import React from 'react'
import CheckIcon from '@mui/icons-material/Check'
import PropTypes from 'prop-types'
import StyledButton from '@/components/Button/Button'
import './Popup.css'

interface PopupPropsType {
  className?: string
  title: string | React.ReactNode
  message?: string
  buttonText?: string
  icon?: React.ReactNode
  onButtonClick?: () => void
  showYesNoButtons?: boolean
  onYesClick?: () => void
  onNoClick?: () => void
}

const Popup = ({
  className,
  title,
  message,
  buttonText,
  icon,
  onButtonClick,
  showYesNoButtons = false,
  onYesClick,
  onNoClick,
}: PopupPropsType) => {
  return (
    <div className="fixed bg-[#0000009e] bg-opacity-20 w-screen h-screen z-50 left-0 top-0">
      <div className="popup-container bg-grad">
        <div className="popup">
          <div className={`popup-icon ${className}`}>
            {icon ? icon : <CheckIcon sx={{ fontSize: '40px' }} />}
          </div>
          <div>
            {title && <h1 className="popup-title">{title}</h1>}
            {message && <div className="popup-message">{message}</div>}
          </div>

          {showYesNoButtons ? (
            <div className="popup-buttons">
              <StyledButton
                className="popup-secondary-button"
                onClick={onYesClick}
              >
                Yes
              </StyledButton>
              <StyledButton className="popup-button" onClick={onNoClick}>
                No
              </StyledButton>
            </div>
          ) : (
            <StyledButton className="popup-button" onClick={onButtonClick}>
              {buttonText || 'Continue'}
            </StyledButton>
          )}
        </div>
      </div>
    </div>
  )
}

Popup.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  message: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  showYesNoButtons: PropTypes.bool,
  onYesClick: PropTypes.func,
  onNoClick: PropTypes.func,
}

export default Popup
